import select from './HospitalSelect.vue'
const FormHospitalSelect = {
  install: function (Vue) {
    Vue.component('FormHospitalSelect', select)
  }
}
export default FormHospitalSelect
